import { defineComponent as _defineComponent } from 'vue'
import {computed, ComputedRef, reactive, watch} from "vue";
  import PerDiemUpdateDialog from "@/views/PerDiem/PerDiemDetailsDialog.vue";
  import PerDiem from "@/model/PerDiem";
  import OrderName from "@/model/OrderName";
  import Order from "@/model/Order";
  import {MessageTypes} from "@/components/message-types";
  import PerDiemDetailsDialogParameters from "@/views/PerDiem/PerDiemDetailsDialogParameters";
  import EmployeeName from "@/model/EmployeeName";
  import {OrderPerDiemDateEmployeeEntry, OrderPerDiemDateEntry} from "@/service/OrderPerDiemMonth";
  import {date} from "@/RouterUtils";
  import eventBus from "@/eventbus";
  import {earliestValidFrom} from "@/store/StoreUtils";
  import moment from "moment";
  import Utils from "@/Utils";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderPerDiemsDate',
  props: {
    dateEntry: {
      type: OrderPerDiemDateEntry,
      default: () => false
    },
    order: {
      type: Order,
      default: () => null
    }
  },
  setup(__props) {

const props = __props

  

  const initialState = {
    selected: new Array<OrderPerDiemDateEmployeeEntry>()
  };

  const state = reactive({...initialState});

  const editable: ComputedRef<boolean> = computed(() => {
    return moment(date.value).isSameOrAfter(moment(earliestValidFrom.value));
  });

  function editSelected() {
    const items = state.selected;

    const cateringEqual = items.every(item => item.perDiem && items[0].perDiem && item.perDiem.catering === items[0].perDiem.catering);
    const catering = (cateringEqual) ? items[0].perDiem.catering : 0;

    const miscEqual = items.every(item => item.perDiem && items[0].perDiem && item.perDiem.misc === items[0].perDiem.misc);
    const misc = (miscEqual) ? items[0].perDiem.misc : 0;

    const perDiemDialogParameters = new PerDiemDetailsDialogParameters();
    const employees = items.map(item => item.employee);
    perDiemDialogParameters.date = date.value;
    perDiemDialogParameters.employees = employees;
    perDiemDialogParameters.orders.push((props.order as OrderName));

    const perDiem: PerDiem = new PerDiem();
    perDiem.catering = catering;
    perDiem.misc = misc;
    perDiem.date = date.value;
    perDiem.order = props.order as OrderName;
    perDiemDialogParameters.perDiem = perDiem;

    eventBus.$emit(MessageTypes.OPEN_PERDIEM_DETAILS, perDiemDialogParameters);
  }

  function editItem(item: OrderPerDiemDateEmployeeEntry) {
    const perDiemDialogParameters = new PerDiemDetailsDialogParameters();
    perDiemDialogParameters.date = date.value;
    perDiemDialogParameters.employees.push(item.employee as EmployeeName);
    perDiemDialogParameters.orders.push(props.order as OrderName);
    perDiemDialogParameters.perDiem = item.perDiem;

    eventBus.$emit(MessageTypes.OPEN_PERDIEM_DETAILS, perDiemDialogParameters);
  }

  function selectAll() {
    if (isAllSelected.value) {
      state.selected.splice(0, state.selected.length);
    } else {
      props.dateEntry.employees.forEach(item => state.selected.push(item));
    }
  }

  function select(item: OrderPerDiemDateEmployeeEntry) {
    if (isSelected(item)) {
      Utils.remove(state.selected, item);
    } else {
      state.selected.push(item);
    }
  }

  const isAllSelected = computed(() => {
    return props.dateEntry.employees.length == state.selected.length;
  });

  function isSelected(item: OrderPerDiemDateEmployeeEntry) {
    return state.selected.includes(item);
  }

  watch(() => props.dateEntry, (newValue, oldValue) => {
    // Deselect all if data has reloaded
    state.selected.splice(0, state.selected.length);
  });


return { __sfc: true,props, initialState, state, editable, editSelected, editItem, selectAll, select, isAllSelected, isSelected, PerDiemUpdateDialog }
}

})